import React from 'react';

export function EpicIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      width="20"
      viewBox="0 0 20 20"
      fill="#d946ef"
    >
      <path d="M9.999 2.5 12.35 7.697l5.14.624-3.772 3.68.89 5.146L9.999 15.6l-4.61 2.547.89-5.146L2.507 8.32l5.14-.624Z" />
    </svg>
  );
}
